import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["walletInput"]

    async pasteWalletAddress(event) {
        event.preventDefault()

        try {
            // Read from clipboard
            const text = await navigator.clipboard.readText()
            const trimmedAddress = text.trim()

            // Set the value in the input (clear first, then set new value)
            // Validation will be done by backend on form submit
            if (this.hasWalletInputTarget) {
                this.walletInputTarget.value = ""
                this.walletInputTarget.value = trimmedAddress
                // Trigger input event to notify any listeners (including validation controller)
                this.walletInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
                this.walletInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
            }
        } catch (error) {
            console.error("Failed to read from clipboard:", error)
        }
    }
}

